import React, {Component} from 'react';
import {Table, Badge, Dropdown, DropdownItem, DropdownMenu, DropdownToggle,
    Input, Progress, Card, Breadcrumb, BreadcrumbItem} from 'reactstrap';

import {Link} from 'react-router-dom';

import {serverPath} from "./common";
import axios from 'axios';

//Route: /algorithms
//Route: /s/courses/:courseId/allProblems
class AllProblemsPage extends Component{
    constructor(props){
        super(props);

        this.state={
            ALL_PROBLEMS: [],//THIS IS CONST, DO NOT CHANGE IT EVER(except in getData)
            problemsToShow:[],
            tags:[],
            user: null,

            //input 
            nameInputState: "",
			topicInputState: "",
			authorInputState: "",
            //tag dropdown
            selectedTag : "",
            isTagDropdownOpen: false,

            //sorting order
            problemIdAsc: false,
            nameAsc: false, 
            scoreAsc: false, 
            totalSolutionsAsc: false,
            topicAsc: false,
			authorAsc: false,

            sortBy : "",
        };
        this.tagDropdownToggle = this.tagDropdownToggle.bind(this);
    }
    //dropdown toggles
    tagDropdownToggle(){
        this.setState({
            isTagDropdownOpen:!this.state.isTagDropdownOpen,
        });
    }
    getData(){
        axios.get(serverPath + "authService.php",{
            params: {
                action: 'whoIsLoggedIn'
            }
        }).then((response) => {
            var user = response.data;
            if(user === null) {
                this.props.history.push("/home");
            }
            
            if(this.props.match.url === "/algorithms"){
                axios.get(serverPath + "problemsService.php", {
                    params:{
                        action:"getAlgorithmsData",
                        studentId: user.userId,
                    }
                }).then((response)=>{
                    this.setState({
                        user: user,
                        tags:response.data.tags,
                        ALL_PROBLEMS:[].concat(response.data.problems),
                        problemsToShow:response.data.problems,
                    });
                });
            }
            else{
                axios.get(serverPath + "problemsService.php", {
                    params:{
                        action:"getAllProblemsForCourse",
                        studentId: user.userId,
                        courseId: this.props.match.params.courseId,
                    }
                }).then((response)=>{
                    this.setState({
                        user: user,
                        tags:response.data.tags,
                        ALL_PROBLEMS:[].concat(response.data.problems),//creates copy of existing array
                        problemsToShow:response.data.problems,
                    });
                });
            }
        });
    }

    componentDidMount(){
        this.getData();
    }

/*********************************************SORTING *********************************************/

    numSortCmp(val1, val2, asc, pid1, pid2) {
        var diff = val1-val2;
        if(diff !== 0)  {
            return asc ? diff : -diff;
        }
        else {
            return pid1 - pid2;
        }
    }

    numSortWrapper(type){
        var problems = this.state.problemsToShow;

        switch (type){
            case "problemId":
                problems.sort((problem1, problem2)=>{
                    return this.numSortCmp(
                                            problem1.problemId, problem2.problemId,
                                            this.state.problemIdAsc,
                                            0, 0);
                });
                break;
            case "score":
                problems.sort((problem1, problem2)=>{
                    return this.numSortCmp(
                                            problem1.score, problem2.score,
                                            this.state.scoreAsc,
                                            problem1.problemId, problem2.problemId);
                });
                break;
            case "timesSolved":
                problems.sort((problem1, problem2)=>{
                    return this.numSortCmp(
                                        problem1.timesSolved,problem2.timesSolved,
                                        this.state.totalSolutionsAsc,
                                        problem1.problemId, problem2.problemId);
                });
                break;
            case "topic":
				problems.sort((problem1, problem2)=>{
					return this.numSortCmp(
										problem1.topicType,problem2.topicType,
										this.state.topicAsc,
										problem1.problemId, problem2.problemId);
					});
				break;
			case 'author':
				problems.sort((p1, p2)=>{
					return this.numSortCmp(
						p1.author, p2.author, this.state.authorAsc, p1.problemId, p2.problemId
					);
				});
            break;
            default: 
                console.log("Unknown type in numSortWrapper");
        }
        this.setState({problemsToShow:problems});
    }

	stringSortWrapper(type){
		let problems = this.state.problemsToShow;
		switch(type){
			case 'name':
				problems.sort((problem1, problem2)=>{
					if (problem1.problemName <= problem2.problemName){
						return this.state.nameAsc ? -1 : 1;
					}
					else
						return this.state.nameAsc ? 1 : -1;
				});
				break;
			case 'author':
				problems.sort((problem1, problem2)=>{
					let a1 = problem1.author
					let a2 = problem2.author;
					if (a1 > a2){
						return this.state.authorAsc ? -1 : 1;
					}
					else if(a1 < a2){
						return this.state.authorAsc ? 1 : -1;
					}
					else{
						return problem1.problemId - problem2.problemId;
					}
				});
				break;
			default:
				console.log("Unknown type in stringSortWrapper");
		}
        this.setState({problemsToShow:problems});
	}
/*******************************************FILTERING *******************************************/
    finalFilter(name, tag, topic, author){
        var problems = this.state.ALL_PROBLEMS;
        if(name !== ""){
            problems = problems.filter((problem)=>{
                return problem.problemName.toLowerCase().indexOf(name.toLowerCase())!== -1;
            });
        }
        
        if(tag !== ""){
            problems = problems.filter((problem)=>{
                return (
                    problem.tags.indexOf(tag) !== -1
                )
            });
        }

        if(topic !== ""){
            problems = problems.filter((problem)=>{
                return problem.topicName.toLowerCase().indexOf(topic.toLowerCase())!== -1;
            });
		}

		if(author !== ""){
            problems = problems.filter((problem)=>{
                return problem.author.toLowerCase().indexOf(author.toLowerCase())!== -1;
            });
		}
		

        this.setState({problemsToShow:problems,sortBy: "",});

    }
/*******************************************HANDLERS********************************************/
    handleNameClicked(){
        this.setState({nameAsc: !this.state.nameAsc, sortBy: 'name',});
        this.stringSortWrapper('name');
    }

    handleTagClicked(tag){
        this.setState({
            selectedTag:tag,
            
        });
        this.finalFilter(this.state.nameInputState, tag, this.state.topicInputState);
    }

    handleProblemIdClicked(){
        this.setState({problemIdAsc: !this.state.problemIdAsc, sortBy: 'id',});
        this.numSortWrapper("problemId");
    }

    handleScoreClicked(){
        this.setState({scoreAsc: !this.state.scoreAsc, sortBy: 'score',});
        this.numSortWrapper("score");
    }

    handleTotalClicked(){
        this.setState({totalSolutionsAsc: !this.state.totalSolutionsAsc, sortBy: 'total',});
        this.numSortWrapper("timesSolved");
    }

    handleTopicClicked(){
        this.setState({topicAsc: !this.state.topicAsc, sortBy: 'topic',});
        this.numSortWrapper("topic");
	}
	
	handleAuthorClicked(){
		this.setState({authorAsc: !this.state.authorAsc, sortBy: 'author'});
		this.stringSortWrapper('author');
	}

    handleCancelAll(){
        this.setState({
            nameInputState: "",
			topicInputState: "",
			authorInputState: "",
            selectedTag: "",
            sortBy: "",
            problemsToShow: [].concat(this.state.ALL_PROBLEMS),
            problemIdAsc: false,
            nameAsc: false, 
            scoreAsc: false, 
            totalSolutionsAsc: false,
            topicAsc: false,

        });
    }

    handleNameInputChange(event){
        this.setState({
            nameInputState:event.target.value.toLowerCase(),
        });
        this.finalFilter(event.target.value, this.state.selectedTag, this.state.topicInputState,
						this.state.authorInputState);   
    }

    handleTopicInputChange(event){
        this.setState({
            topicInputState:event.target.value.toLowerCase(),
        });
        this.finalFilter(this.state.nameInputState, this.state.selectedTag, event.target.value,
						this.state.authorInputState);  
	}
	
	handleAuthorInputChanged(event){
		this.setState({
			authorInputState: event.target.value.toLowerCase(),
		});
		this.finalFilter(this.state.nameInputState, this.state.selectedTag, this.state.topicInputState,
						event.target.value.toLowerCase());
	}

/***************************************RENDER HELPERS*****************************************/

    createProblemsTable(){
        var problems = this.state.problemsToShow;
        if(problems !== null){
            var problemsTable = problems.map((problem)=>{
                return this.createProblemTableRow(problem);
            });
            return(
                <React.Fragment>
                    <Table size="sm" hover bordered className={'mt-1'}>
                        <thead>
                            <tr>
                                <th onClick={()=>this.handleProblemIdClicked()} className="th-sort-link">
                                <span className={this.isSortActive('id', this.state.problemIdAsc)}></span>
                                ID
                                </th>

                                <th onClick={()=>this.handleNameClicked()} className="th-sort-link">
                                    <span className={this.isSortActive('name', this.state.nameAsc)}>
                                    </span> Ime
                                </th>

                                {this.props.match.url === '/algorithms' && <th>Tagovi</th>}

                                {
                                    this.props.match.url !== "/algorithms" && 
                                    <th onClick={()=>this.handleTopicClicked()} className="th-sort-link">
                                        <span className={this.isSortActive('topic', this.state.topicAsc)}></span>
                                        Tema
                                    </th>
                                }
                                <th onClick={()=>this.handleScoreClicked()} className="th-sort-link">
                                    <span className={this.isSortActive('score', this.state.scoreAsc)}></span>
                                    Vaš najbolji rezultat
                                </th>
                                <th onClick={()=>this.handleTotalClicked()} className="th-sort-link">
                                <span className={this.isSortActive('total',this.state.totalSolutionsAsc)}></span>
                                Ukupno rešilo
                                </th>
								{
									this.props.match.url === "/algorithms" &&
									<th onClick={()=>this.handleAuthorClicked()} className="th-sort-link">
									<span className={this.isSortActive('author',this.state.authorAsc)}></span>
										Autor
									</th>
								}
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderFilterOptions()}
                            {problemsTable}
                        </tbody>
                    </Table>
                </React.Fragment>
            );
        }
        else{
            return (<div></div>);
        }
    }

    createProblemTableRow(problem){
        var problemLink;
        if(problem.topicId){
            problemLink =   "/" + this.state.user.roleName.charAt(0)
                                + "/courses/" + problem.courseId + "/topic/" + problem.topicId
                                + "/problem/" + problem.problemId;
        }
        else{
            problemLink = "/" + this.state.user.roleName.charAt(0)
                        + "/problem/" + problem.problemId;
        }
        return(
            <tr>
                <td>{problem.problemId}</td>
                <td><a href = {problemLink} className="default-link">{problem.problemName}</a></td>
                {this.props.match.url === '/algorithms' && <td>{this.createTagsBadges(problem.tags)}</td>}
                {this.props.match.url !== "/algorithms" && <td>{problem.topicName}</td>}
                <td>{this.showScore(problem.score)}</td>
                <td>{problem.timesSolved}</td>
				{this.props.match.url === '/algorithms' && <td>{problem.author}</td>}
            </tr>
        );
    }

    createTagsBadges(tags, sort){
        var badges = tags.map((tag)=>{
            return(
                <Badge onClick={()=>this.handleTagClicked(tag)} pill color='success' className={'m-1'}>
                    {tag}
                </Badge>
            );
        });
        return badges;
    }

    showScore(score){
        return(
            <Progress value={score} color={score === 100 ? 'success' : score >= 50 ? 'warning' : 'info'}>
                {score}%
            </Progress>
        );
    }

    isSortActive(sortToCheck, asc){
        if(this.state.sortBy === sortToCheck){
            if(asc){
                return 'fa fa-caret-down';
            }
            else
                return 'fa fa-caret-up';
        }
        else return '';
    }

    renderFilterOptions(){
        var tags = this.state.tags.map((tag, index)=>{
            return(
                <DropdownItem key={index} onClick={()=>this.handleTagClicked(tag.name)}>
                    {tag.name}
                </DropdownItem>
            );
        })

        return(
            <tr>
                <td>
                    <span className="fa fa-remove fa-2x" title="Poništi sve filtere" onClick={()=>{this.handleCancelAll()}}> </span>
                </td>
                <td>
                    <Input  type='text'
                            value={this.state.nameInputState}
                            onChange={(e)=>this.handleNameInputChange(e)}
                            placeholder={'Filter po imenu'}
                    />
                </td>
                {
                    this.props.match.url === '/algorithms' &&
                    <td>
                        <Dropdown
                            isOpen={this.state.isTagDropdownOpen}
                            toggle = {this.tagDropdownToggle}>

                            <DropdownToggle caret>
                                {this.state.selectedTag}
                            </DropdownToggle>
                            <DropdownMenu>
                                {tags}
                            </DropdownMenu>
                        </Dropdown>
                    </td>
                }
                {
                    this.props.match.url !== '/algorithms' &&
                    <td>
                        <Input  type='text'
                                value={this.state.topicInputState}
                                onChange={(e)=>this.handleTopicInputChange(e)}
                                placeholder={'Filter po temi'}/>
                    </td>

                }
                <td></td>
                <td></td>
				{this.props.match.url === '/algorithms' && 
					<td>
						<Input 	type='text'
								value={this.state.authorInputState}
								onChange={(e)=>this.handleAuthorInputChanged(e)}
								placeholder='Filter po autoru'/>
					</td>
				}
            </tr>
        );
    }

    render(){
        return(
            <React.Fragment>
                {
                    this.props.match.url === '/algorithms'
                        ?
                            <div className="col-10 offset-1 mt-5" style={{'min-height': '80vh'}}>
                                <Breadcrumb>
                                    <BreadcrumbItem><Link to="/home">Početna</Link></BreadcrumbItem>
                                    <BreadcrumbItem active>Algoritamski zadaci</BreadcrumbItem>
                                </Breadcrumb>
                                <div className="card-container">
                                    <Card>
                                        {this.createProblemsTable()}
                                    </Card>
                                </div>
                            </div>
                        :
                        <div className="ml-4 mr-4">
                            <Breadcrumb>
                                <BreadcrumbItem active>Svi zadaci</BreadcrumbItem>
                            </Breadcrumb>
                            <div className="card-container">
                                <Card className="">
                                    <h3 className="mb-3 text-center"> Svi zadaci na izabranom kursu </h3>
                                    {this.createProblemsTable()}
                                </Card>
                            </div>
                        </div>
                }
            </React.Fragment>
        );
    }
}



export default AllProblemsPage;
